import { all, call, takeEvery, put, select } from 'redux-saga/effects'
import { getTotalRegistrations, getSceneData, getCurrentData } from 'services/virtual/analytics'
import { initChat } from 'services/virtual/chat'
import { message } from 'antd'
import actions from './actions'

export function* GET_TOTAL_REGISTRATIONS() {
  try {
    const result = yield call(getTotalRegistrations)
    if (result.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          totalRegistrations: result.data,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* GET_SCENE_DATA() {
  try {
    const result = yield call(getSceneData)
    if (result.status === 200) {
      const tempChannels = []
      result.data.map(item => {
        tempChannels.push(item.id)
        return ''
      })
      console.log('tempChannels', tempChannels)
      yield put({
        type: actions.SET_STATE,
        payload: {
          sceneData: result.data,
          subscribedScenes: tempChannels,
        },
      })
      yield put({
        type: actions.LIVE_CHANNELS,
        payload: { subscribedScenes: tempChannels },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* GET_CURRENT_DATA() {
  try {
    const result = yield call(getCurrentData)
    if (result.status === 200) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          currentData: result.data,
        },
      })
    }
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export function* LIVE_CHANNELS(data) {
  try {
    const state = yield select()
    const {
      virtualSetup: { pubnub },
      // analytics:{subscribedScenes},
    } = state

    let pubnubNew = ''
    if (pubnub === null) {
      pubnubNew = yield call(initChat, 'wiz365-admin')
      yield put({
        type: actions.SET_STATE,
        payload: {
          pubnub: pubnubNew,
        },
      })
    }
    // console.log('subscribedScenes',data.payload.subscribedScenes)
    yield put({
      type: 'chat/SUBSCRIBE_CHANNELS',
      payload: {
        channels: data.payload.subscribedScenes,
        pubnub: pubnubNew,
        withPresence: true,
      },
    })
    yield put({
      type: actions.SET_STATE,
      payload: {
        pubnub: pubnubNew,
      },
    })
    yield put({
      type: 'chat/PUBNUB_ADD_LISTERNER',
      payload: {
        channels: data.payload.subscribedScenes,
        pubnub: pubnubNew,
        withPresence: true,
      },
    })
  } catch (err) {
    console.log(err.response)
    message.error(`${err.response.status}:${err.response.data.message}`)
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_TOTAL_REGISTRATIONS, GET_TOTAL_REGISTRATIONS),
    takeEvery(actions.GET_SCENE_DATA, GET_SCENE_DATA),
    takeEvery(actions.GET_CURRENT_DATA, GET_CURRENT_DATA),
    takeEvery(actions.LIVE_CHANNELS, LIVE_CHANNELS),
  ])
}
